import { ref, computed } from 'vue';

export const useSkeletonLoader = (defaultCount: number = 5) => {
  // Preserved row count for skeleton loading
  const preservedRowCount = ref<number>(0);

  // Calculate dynamic skeleton count based on preserved row count
  const dynamicSkeletonCount = computed(() => {
    if (preservedRowCount.value > 0) {
      // Use the exact number of rows that were visible before loading
      return preservedRowCount.value;
    }
    // Fallback to default count
    return defaultCount;
  });

  // Preserve current row count before loading starts
  const preserveRowCount = (currentRowCount: number) => {
    preservedRowCount.value = currentRowCount;
  };

  // Reset preserved count after loading
  const resetRowCount = () => {
    preservedRowCount.value = 0;
  };

  return {
    dynamicSkeletonCount,
    preserveRowCount,
    resetRowCount,
  };
};
